var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.01_Welcome-page",
    transform: "translate(-97.000000, -145.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121,145 L100,145 C98.35,145 97,146.35 97,148 L97,169 C97,170.65 98.35,172 100,172 L121,172 C122.65,172 124,170.65 124,169 L124,148 C124,146.35 122.65,145 121,145 Z M112.045,151.09 L113.635,149.5 L115.75,151.615 L117.865,149.5 L119.455,151.09 L117.34,153.205 L119.455,155.32 L117.865,156.91 L115.75,154.81 L113.635,156.925 L112.045,155.335 L114.16,153.22 L112.045,151.09 Z M101.875,152.08 L109.375,152.08 L109.375,154.33 L101.875,154.33 L101.875,152.08 Z M109.75,164.5 L106.75,164.5 L106.75,167.5 L104.5,167.5 L104.5,164.5 L101.5,164.5 L101.5,162.25 L104.5,162.25 L104.5,159.25 L106.75,159.25 L106.75,162.25 L109.75,162.25 L109.75,164.5 Z M119.5,166.375 L112,166.375 L112,164.125 L119.5,164.125 L119.5,166.375 Z M119.5,162.625 L112,162.625 L112,160.375 L119.5,160.375 L119.5,162.625 Z",
    id: "Calculator"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.87a85e6e064a747d72256fccc787da3f.svg";
export { ForwardRef as ReactComponent };